import { Component, OnInit, Input, Renderer2, ElementRef } from '@angular/core';
import { encapsulation } from '../encapsulation';

@Component({
    selector: 'ubx-heading',
    templateUrl: './heading.component.html',
    host: { class: 'ubx-heading' },
    encapsulation
})
export class UBXHeadingComponent implements OnInit {
    @Input() type: Heading = Heading.H2;
    @Input() marg: Marg;
    @Input() weig: Weig;

    heading = 'h';
    Heading = Heading;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
    ) {}

    ngOnInit() {
        this.setMarg(this.marg);
        this.setWeig(this.weig);
    }

    private setMarg(marg: Marg) {
        return marg && this.appendClass(`mg:b${Marg[marg]}`);
    }
    private setWeig(weig: Weig) {
        return weig && this.appendClass(`fw:${Weig[weig]}`);
    }
    private appendClass(name: string) {
        this.renderer.addClass(this.el.nativeElement, name);
    }
}

enum Heading {
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    H4 = 'h4',
    H5 = 'h5',
    H6 = 'h6'
}
enum Marg {
    xl = '50', l = '30', m = '20', s = '10', xs = '5'
}
enum Weig {
    thk = 'bd', nrm = 'nm', thn = 'th'
}
